import './bootstrap';
import componentLoader from './componentLoader';

// Create event listeners for component re-evaluation etc.
componentLoader.createListeners();

componentLoader.check();
